module.exports = __webpack_public_path__ + "media/images/icons/circles-c33e30a9fef6b577a46ef04f3af41869.svg";